import Vue from 'vue'
import EventBus from '../_event-bus'
import { $$ } from '../_utils'

Vue.component('vue-points-counter', {
  template: '#vue-points-counter-template',
  props: ['initialItems'],
  data() {
    return {
      itemCount: 10,
      orderPointsAflo: 0,
      orderPointsEdu: 0,
      items: this.initialItems ? this.initialItems : [],
    }
  },
  methods: {
    countOrderPoints(items) {
      this.orderPointsAflo = 0
      this.orderPointsEdu = 0
      items
        .filter(item => item.pointsType === 'edu')
        .forEach(element => (this.orderPointsEdu = this.orderPointsEdu + element.totalPoints))

      items
        .filter(item => item.pointsType === 'aflo')
        .forEach(element => (this.orderPointsAflo = this.orderPointsAflo + element.totalPoints))
    },
    addUpdateCartListener() {
      EventBus.$on('update-cart', this.updateCart)
    },
    updateCart(data) {
      this.items = data
      this.countOrderPoints((this.items = data))
    },
  },
  created() {
    this.addUpdateCartListener()
  },
  mounted() {
    this.countOrderPoints(this.items)
  },
})

const counters = $$('#vue-points-counter-wrapper')
window.addEventListener('DOMContentLoaded', () => {
  if (!counters) return
  counters.forEach(element => {
    new Vue({
      el: element,
    })
  })
})
